import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollFetchPeopleSummaryResponse } from '../types';

const payrollFetchPeopleSummaryQuery = gql`
  query PayrollFetchPeopleSummary {
    payrollFetchPeopleSummary {
      code
      success
      message
      data {
        activeUsers
        activeEmployees
        activeContractors
        dismissed
        draftEmployees
      }
    }
  }
`;

export const getPeopleListSummary = () => {
  return graphQLApi<PayrollFetchPeopleSummaryResponse, {}>({
    query: payrollFetchPeopleSummaryQuery,
  });
};
